import { notifyIntelliWriterAuthBridge } from "./intelliWriterAuthBridge";

export function loginNotificationToExt(
  refresh_token: string,
  accessToken?: string,
) {
  const LOGIN_REFRESH_TOKEN = "CE_REFRESH_TOKEN";
  const message = {
    type: LOGIN_REFRESH_TOKEN,
    payload: refresh_token,
    accessToken,
  };

  window.postMessage(message, window.location.origin);
  notifyIntelliWriterAuthBridge(message);
}
